var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpnkey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13431_127702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 14,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36571 3.57069C5.19126 3.20917 6.82407 4.26457 7.3784 5.83339H12.2495C12.8911 5.83339 13.4164 6.35877 13.4165 7.00038C13.4165 7.64205 12.8912 8.16737 12.2495 8.16737V9.33339C12.2495 9.97505 11.7242 10.5004 11.0825 10.5004C10.4411 10.5001 9.91649 9.9749 9.91649 9.33339V8.16737H7.3784C6.89999 9.52638 5.60489 10.5004 4.0825 10.5004C1.90119 10.5001 0.186516 8.49974 0.664536 6.24257C0.944536 4.90673 2.02987 3.83902 3.36571 3.57069ZM4.0825 5.83339C3.4411 5.83365 2.91656 6.35893 2.91649 7.00038C2.91649 7.64189 3.44105 8.16711 4.0825 8.16737C4.72417 8.16737 5.2495 7.64205 5.2495 7.00038C5.24942 6.35877 4.72412 5.83339 4.0825 5.83339Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13431_127702)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#A6B0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnkey);
export default __webpack_public_path__ + "static/media/vpnkey.ef8050d6.svg";
export { ForwardRef as ReactComponent };